module.exports = __webpack_public_path__ + "img/2-1.c03e4832.jpg";